import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '../entity'
import { IDocumentEngineTemplate } from './IDocumentEngineTemplate'
import { DocumentEngineTemplateVersion } from './DocumentEngineTemplateVersion'

export class DocumentEngineTemplate extends Entity<IDocumentEngineTemplate> {
  id: number
  name: string
  code: string
  description: string
  type: string
  message?: string

  @Type(() => DocumentEngineTemplateVersion)
  currentVersion: DocumentEngineTemplateVersion

  public static new(payload: unknown): DocumentEngineTemplate {
    const entity = plainToInstance(DocumentEngineTemplate, payload)
    return entity
  }
}
